import { PhoneDisplay, CallButton } from "@/components/CallButton";
import { Reveal } from "@/components/Reveal";

export const ContactCTA = () => (
  <section
    className="grain relative overflow-hidden bg-ink py-24 text-center md:py-36"
    data-testid="contact-cta"
  >
    <div className="blueprint-grid absolute inset-0 opacity-30" />
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/[0.07] blur-[130px]" />
    <div className="relative z-10 mx-auto max-w-3xl px-5">
      <Reveal>
        <div className="mb-6 flex items-center justify-center gap-3 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold">
          <span className="h-px w-8 bg-gold" /> Call Now <span className="h-px w-8 bg-gold" />
        </div>
        <h2 className="font-heading text-4xl font-black uppercase leading-none tracking-tightest text-white sm:text-5xl lg:text-6xl">
          Speak directly with Jose
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-steel">
          Tell us about your lock or safe job and we'll let you know how we can help.
          No online booking — just a real conversation.
        </p>
        <div className="mt-10 flex flex-col items-center gap-6">
          <PhoneDisplay size="text-4xl sm:text-5xl lg:text-6xl" testid="contact-cta-phone" />
          <CallButton size="lg" showNumber testid="contact-cta-call-btn" />
        </div>
      </Reveal>
    </div>
  </section>
);
